export default "__VITE_ASSET__9d6e955a__"